// @ts-strict-ignore
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { ajaxFetch, buildURLParamsString } from '~/helpers/api';
import { routes } from '~/helpers/routes';

type RequestApproversOptions = {
  label: string;
  value: string;
};

type Options = Omit<UseQueryOptions<RequestApproversOptions[]>, 'queryKey' | 'queryFn'>;

// copied over from existing implementation at 'admin/request-access/index.tsx'
export const useGetRequestApprovers = (options?: Options) => useQuery({
  queryKey: [routes.v3.admin.agents.list],
  queryFn: async () => {
    const params = buildURLParamsString({
      paginateBy: 9999,
      filterBy: { role: { should: ['Manager', 'Admin'] } },
    }, true);

    const {
      data: {
        0: {
          data,
        },
      },
    } = await ajaxFetch(`${routes.v3.admin.agents.list}${params}`);

    const unarchivedAgents = data.filter(acc => acc.archived !== true);
    return unarchivedAgents.reduce((acc: RequestApproversOptions[], { email, full_name }) => {
      // hard check for @alloy.com domain, to avoid issues with @alloy.co
      if (email.slice(-10) === '@alloy.com') {
        acc.push({
          label: full_name,
          value: email,
        });
      }
      return acc;
    }, []);
  },
  ...options,
});
